import React from "react";
import { object, number } from "prop-types";

import CardImage from "../../../atoms/CardImage";
import NumberedHeadline from "../../../molecules/NumberedHeadline";

import "./organism1.m.css";

const Organism1 = ({ story, headlineNumber }) => {
  if (!story) return null;

  return (
    <div styleName="wrapper" className="numbered-card-vertical">
      <CardImage
        className="card-with-image-zoom"
        story={story}
        aspectRatio={[3, 2]}
        imageType="image3x2"
        linkEnable={true}
        widths={[400]}
      />
      <NumberedHeadline story={story} headlineNumber={headlineNumber} />
    </div>
  );
};

Organism1.propTypes = {
  story: object.isRequired,
  headlineNumber: number,
};

export default Organism1;
